/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * modules.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
/**
 * Import module.
 */
import { setDNavBtn } from "./setDNavBtn";
import { setListEmbla } from "./slider/slider-list-embla";
import { setScrollTrigger } from "./setScrollTrigger";
import { smoothScrollTo } from "./smoothScrollTo";
import { createEmblaWithAutoScroll } from "./slider/EmblaCarouselAutoScroll";

const viewport = document.querySelector(".auto-scroll-embla__viewport");
if (viewport) {
	const emblaApi = createEmblaWithAutoScroll(viewport);
	// オプション例: createEmblaWithAutoScroll(viewport, { loop: true }, { speed: 3, startDelay: 500 });
}
/**
 * Do modules.
 */
function modules() {
	setDNavBtn();
	setScrollTrigger();
	smoothScrollTo();
	setListEmbla();
}

export { modules };
